module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-id-ID.4b1aa5b3.jpg";